import axios from '@/plugins/axios';

const client = {
    getProfile: function () {
        return axios.request({
            method: 'GET',
            url: '/user/profile',
        });
    },

    /**
     * 获取用户蓝豆账户
     */
    getBlueBeanAccount() {
        return axios.request({
            method: 'GET',
            url: '/user/blue-bean-account',
        });
    },

    /**
     * 更新个人信息
     */
    updateProfile(data) {
        return axios.request({
            method: 'PUT',
            url: '/user/profile',
            headers: {
                'X-bypass-error': 1,
            },
            data,
        });
    },

    /**
     * 更新账号绑定的手机号
     */
    updatePhoneNumber(data) {
        return axios.request({
            method: 'PUT',
            url: '/user/phone-number',
            headers: {
                'X-bypass-error': 1,
            },
            data,
        });
    },
};

export default client;
